document.addEventListener('DOMContentLoaded', function () {
    quickOrderInit();
});

function quickOrderInit() {
    const tBody = document.getElementById('product-table-body');
    const addLineButton = document.getElementById('add-line-btn');
    const addToCartButton = document.getElementById('add-to-cart-btn');
    const downloadCsvBtn = document.getElementById('download-csv-btn');
    const fileInput = document.getElementById('upload-csv-input');
    const modalCloseBtn = document.querySelector('.modal-close-btn');

    tBody.addEventListener('input', onTableBodyInput);
    tBody.addEventListener('click', onTableBodyClick);
    addLineButton.addEventListener('click', addLine);
    addToCartButton.addEventListener('click', addToCart);
    downloadCsvBtn.addEventListener('click', downloadCSV);
    fileInput.addEventListener('change', uploadCSV);
    modalCloseBtn.addEventListener('click', closeVariantModal)

    handleQuickOrderMessage();
}

function onTableBodyInput(event) {
    if (event.target && event.target.matches('.sku-input')) {
        handleSkuInputChange(event.target);
    }
    if (event.target && event.target.matches('.qty-input')) {
        handleQtyInputChange(event.target);
        updateSubtotal(event.target);

    }
}

function onTableBodyClick(event) {

    if (event.target && event.target.matches('.info-icon')) {
        showQtyRulesPopup(event.target);
    } else if (event.target && event.target.matches('.reset-btn')) {
        resetRow(event.target);
    } else if (event.target && event.target.matches('.edit-btn')) {
        editRow(event.target);
    }else if (!event.target.matches('.qty-rules-popup')) {
        const popup = document.querySelector('.qty-rules-popup');
        if (popup) {
            popup.remove();
        }
    }
}

let debounceTimeout;

async function handleSkuInputChange(input) {
    const query = input.value;

    if (debounceTimeout) {
        clearTimeout(debounceTimeout);
    }

    debounceTimeout = setTimeout(async () => {
        if (query.length < 3) {
            return;
        }

        const products = await fetchProducts(query);
        const dropdown = input.nextElementSibling;
        dropdown.innerHTML = '';

        if (products.length > 0) {
            dropdown.style.display = 'block';
            products.forEach(product => {
                const item = createDropdownItem(product, input);
                dropdown.appendChild(item);
            });
        } else {
            dropdown.innerHTML = '<li>No results</li>';
            dropdown.style.display = 'block';
        }
    }, 500);
}

function handleQtyInputChange(qtyInput) {
    const currentQty = parseInt(qtyInput.value, 10);
    const isValid = currentQty >= qtyInput.min && currentQty <= qtyInput.max;

    if (isValid) {
        qtyInput.classList.remove('error');
    } else {
        qtyInput.classList.add('error');
    }
}

function createDropdownItem(product, input) {
    const item = document.createElement('li');

    item.innerHTML = `
    <div class="product-info">
        <img src="${product.image}" alt="${product.title}">
        <span class="product-title">${product.title}</span>
    </div>
    `;

    item.dataset.productId = product.id;

    item.onclick = function () {
        if (product.customOptionsForm) {
            openVariantModal(product, input);
        } else if (product.variants.length === 1) {
            selectProduct(product.variants[0], product, input);
        } else {
            openVariantModal(product, input);
        }
        input.nextElementSibling.style.display = 'none';
    };

    return item;
}

function selectProduct(variant, product, input) {
    if (!variant) {
        alert(`The product "${product.title}" is not available for sale.`);
        return;
    }

    input.value = variant.sku || '';
    const row = input.closest('tr');

    row.querySelector('.product-photo').innerHTML = `
        <img src="${variant.image || ''}" alt="${product.title}" />
    `;

    row.querySelector('.product-details').innerHTML = `
        <a href="/products/${product.handle}?variant=${variant.variantId}" class="product-details-title">${product.title}</a>
        <span class="variant-info">${getVariantInfo(variant)}</span><br>
        <span class="custom-options-info">${getCustomOptionsInfo(variant)}</span><br>
        $${parseFloat(variant.price).toFixed(2)}
    `;

    const qtyInput = row.querySelector('.qty-input');
    qtyInput.value = product.minCartQty;
    qtyInput.min = product.minCartQty || 1;
    qtyInput.step = product.qtyIncrements || 1;

    if (product.maxCartQty) {
        qtyInput.max = product.maxCartQty;
    }

    qtyInput.dataset.productPrice = variant.price;
    qtyInput.dataset.variantId = variant.variantId;

    let infoIcon = qtyInput.nextElementSibling;
    if (!infoIcon || !infoIcon.classList.contains('info-icon')) {
        infoIcon = document.createElement('span');
        infoIcon.className = 'info-icon';
        infoIcon.textContent = 'i';
        qtyInput.insertAdjacentElement('afterend', infoIcon);
    }

    const hasQtyRules =
        (product.minCartQty && product.minCartQty > 1) ||
        (product.qtyIncrements && product.qtyIncrements > 1) ||
        (product.maxCartQty && ![0, 10000, 100000].includes(product.maxCartQty));

    if (hasQtyRules) {
        infoIcon.style.display = 'inline-block';
    } else {
        infoIcon.style.display = 'none';
    }

    row.querySelector('.subtotal').textContent = `$${(variant.price * qtyInput.value).toFixed(2)}`;
    row.querySelector('.reset-btn').disabled = false;
    row.querySelector('.edit-btn').disabled = false;
    qtyInput.disabled = false;

    row.dataset.variantId = variant.variantId;
    row.dataset.productTitle = product.title;
}

// Helper function to generate variant information string (e.g. "Size: M, Color: Red")
function getVariantInfo(variant) {
    if (!variant.options || variant.options.length < 1) {
        return '';
    }

    const hasDefaultTitle = variant.options.some(option => option.value === 'Default Title');
    if (hasDefaultTitle) {
        return '';
    }

    return variant.options.map(option => `${option.name}: ${option.value}`).join('<br>');
}

function getCustomOptionsInfo(variant) {
    if (!variant.customOptions || variant.customOptions.length === 0) {
        return '';
    }

    return variant.customOptions.map(option => {
        const optionValue = option.value || 'N/A';
        return `${option.name}: ${optionValue}`;
    }).join('<br>');
}

// Open variant modal with a select dropdown for each variant (separate select for SIZE, COLOR, etc.)
function openVariantModal(product, input) {
    const modal = document.getElementById('variantModal');
    const modalList = document.getElementById('variantModalList');
    const modalTitle = document.getElementById('modalProductTitle');
    const productImage = document.getElementById('modalProductImage');

    if (!modal || !modalList || !modalTitle || !productImage) {
        console.error('Modal elements not found');
        return;
    }

    modalTitle.textContent = product.title;
    productImage.src = product.image || '';
    modalList.innerHTML = '';

    const hasVariants = product.variants && product.variants.length > 0;
    const hasCustomOptions = product.customOptionsForm && product.customOptionsForm.fields.length > 0;

    if (hasVariants && product.variants.length === 1) {
        const singleVariant = product.variants[0];
        if (!hasCustomOptions) {
            selectProduct(singleVariant, product, input);
            return;
        }
    }

    if (hasVariants && !(product.variants.length === 1 && hasCustomOptions)) {
        const filteredVariants = product.variants.filter(variant => {
            return !variant.options.some(option => option.value === 'Default Title');
        });

        if (filteredVariants.length > 0) {
            const variantOptions = groupVariantsByOptionType({ variants: filteredVariants });
            createSelectDropdownForEachVariantOptionType(modalList, variantOptions);

            // Add event listener for custom textarea
            const sanitizedOptionType = Object.keys(variantOptions)[0].replace(/\s+/g, '-');
            const variantDropdown = document.querySelector(`#variantSelect-${sanitizedOptionType}`);
            if (variantDropdown) {
                variantDropdown.addEventListener('change', (e) => {
                    handleCustomOptionSelection(e.target, modalList);
                });
            }
        }
    }

    if (hasCustomOptions) {
        renderCustomOptionsForm(product.customOptionsForm, modalList);
    }

    appendConfirmButton(hasVariants, hasCustomOptions, product, modalList, input);

    modal.style.display = 'block';
    document.getElementById('modalBackdrop').style.display = 'block';
}

function renderCustomOptionsForm(customOptionsForm, container) {
    const form = document.createElement('form');
    form.id = 'customOptionsForm';
    form.classList.add('product-options__container');

    customOptionsForm.fields.forEach(optionField => {
        const optionData = optionField.reduce((acc, field) => {
            acc[field.key] = field.value;
            return acc;
        }, {});

        if (!optionData.option_title) {
            console.warn('Option title is missing for:', optionData);
            return;
        }

        const optionName = optionData.option_title.replace(/\s+/g, '-');
        const isRequired = optionData.option_is_required === "true" ? 'required' : '';
        const requiredMark = optionData.option_is_required === "true" ? '<span class="required-mark">*</span>' : '';
        let fieldHTML = '';

        if (optionData.option_type === 'area') {
            fieldHTML = `
                <div class="variant-section">
                    <label for="${optionName}" class="product-options__label">
                        ${optionData.option_title} ${requiredMark}
                    </label>
                    <textarea id="${optionName}" name="${optionName}" rows="4" class="product-options area" maxlength="${optionData.option_max_characters || ''}" ${isRequired}></textarea>
                </div>
            `;
        } else if (optionData.option_type === 'field') {
            fieldHTML = `
                <div class="variant-section">
                    <label for="${optionName}" class="product-options__label">
                        ${optionData.option_title} ${requiredMark}
                    </label>
                    <input type="text" id="${optionName}" name="${optionName}" maxlength="${optionData.option_max_characters || ''}" class="product-options field" ${isRequired}>
                </div>
            `;
        } else if (optionData.option_type === 'drop_down') {
            const options = (optionData.option_row_title || '').split(',').map(opt => `<option value="${opt.trim()}">${opt.trim()}</option>`).join('');
            fieldHTML = `
                <div class="variant-section">
                    <label for="${optionName}" class="product-options__label">
                        ${optionData.option_title} ${requiredMark}
                    </label>
                    <select id="${optionName}" name="${optionName}" class="variant-section_select" ${isRequired}>
                        <option selected disabled>Choose an option</option>
                        ${options || ''}
                    </select>
                </div>
            `;
        } else if (optionData.option_type === 'checkbox') {
            fieldHTML = `
                <div class="variant-section">
                    <div class="product-options__checkbox-wrapper">
                        <input type="checkbox" id="${optionName}" name="${optionName}" class="product-options checkbox" ${isRequired}>
                        <label for="${optionName}" class="product-options__checkbox-label">
                            ${optionData.option_row_title || 'Option'} ${requiredMark}
                        </label>
                    </div>
                </div>
            `;
        } else if (optionData.option_type === 'radio') {
            const options = (optionData.option_row_title || '').split(',').map(opt => `
                <div class="variant-section">
                    <div>
                        <input type="radio" id="${optionName}-${opt.trim()}" name="${optionName}" value="${opt.trim()}" class="product-options radio" ${isRequired}>
                        <label for="${optionName}-${opt.trim()}" class="product-options__radio-label">
                            ${opt.trim()}
                        </label>
                    </div>
                </div>
            `).join('');
            fieldHTML = `<fieldset><legend>${optionData.option_title} ${requiredMark}</legend>${options || ''}</fieldset>`;
        }

        form.innerHTML += fieldHTML;
    });

    container.insertBefore(form, container.querySelector('.add-variant-btn'));
}

function handleCustomOptionSelection(selectElement, modalList) {
    const customOptionTextareaId = 'customOptionTextarea';
    const existingTextarea = document.getElementById(customOptionTextareaId);

    if (selectElement.value === 'Custom') {
        console.log("to tu")
        if (!existingTextarea) {
            const textareaWrapper = document.createElement('form');
            textareaWrapper.id = 'customOptionWrapper';
            textareaWrapper.classList.add('variant-section');

            textareaWrapper.innerHTML = `
                <label for="${customOptionTextareaId}" class="product-options__label">
                    Imprint <span class="required-mark">*</span>
                </label>
                <textarea id="${customOptionTextareaId}" 
                          name="imprint"
                          rows="4" 
                          class="product-options area" 
                          required></textarea>
            `;

            modalList.insertBefore(textareaWrapper, modalList.querySelector('.add-variant-btn'));
        }
    } else {
        if (existingTextarea) {
            existingTextarea.parentElement.remove();
        }
    }
}

function groupVariantsByOptionType(product) {
    const variantOptions = {};

    product.variants.forEach(variant => {
        variant.options.forEach(option => {
            if (!variantOptions[option.name]) {
                variantOptions[option.name] = [];
            }
            if (!variantOptions[option.name].includes(option.value)) {
                variantOptions[option.name].push(option.value);
            }
        });
    });

    return variantOptions;
}

function createSelectDropdownForEachVariantOptionType(modalList, variantOptions) {
    Object.keys(variantOptions).forEach(optionType => {
        const variantSection = document.createElement('div');
        variantSection.classList.add('variant-section');

        const label = document.createElement('label');
        label.textContent = `Choose ${optionType}:`;
        variantSection.appendChild(label);

        const select = document.createElement('select');
        const sanitizedOptionType = optionType.replace(/\s+/g, '-');
        select.id = `variantSelect-${sanitizedOptionType}`;
        select.classList.add("variant-section_select");


        const defaultOption = document.createElement('option');
        defaultOption.textContent = `Select ${optionType}`;
        defaultOption.disabled = true;
        defaultOption.selected = true;
        select.appendChild(defaultOption);

        // Add options for the specific variant type (e.g., SIZE, COLOR)
        variantOptions[optionType].forEach(value => {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            select.appendChild(option);
        });

        variantSection.appendChild(select);
        modalList.appendChild(variantSection);
    });
}

function appendConfirmButton(hasVariants, hasCustomOptions, product, modalList, input) {
    const confirmBtn = document.createElement('button');
    confirmBtn.textContent = 'Select';
    confirmBtn.classList.add('add-variant-btn');
    confirmBtn.onclick = function () {
        let isValid = true;
        let selectedVariant = null;
        let customOptionsData = {};
        const customTextarea = document.getElementById('customOptionTextarea');

        if (hasVariants && !(product.variants.length === 1 && hasCustomOptions)) {
            const selectedVariants = [];
            const variantOptions = groupVariantsByOptionType(product);

            Object.keys(variantOptions).forEach(optionType => {
                const sanitizedOptionType = optionType.replace(/\s+/g, '-');
                const dropdown = document.getElementById(`variantSelect-${sanitizedOptionType}`);

                if (dropdown) {
                    const selectedOption = dropdown.value;
                    if (selectedOption) {
                        selectedVariants.push({ optionType, selectedOption });
                    }
                }
            });


            if (selectedVariants.length === Object.keys(variantOptions).length) {
                selectedVariant = product.variants.find(variant => {
                    return selectedVariants.every(selected => {
                        return variant.options.some(option => option.name === selected.optionType && option.value === selected.selectedOption);
                    });
                });

                if (!selectedVariant) {
                    alert('Please select all required variant options.');
                    isValid = false;
                }
            } else {
                alert('Please select all required variant options.');
                isValid = false;
            }
        } else if (product.variants.length === 1) {
            selectedVariant = product.variants[0];
        }

        if (hasCustomOptions) {
            const customOptionsForm = document.getElementById('customOptionsForm');
            if (customOptionsForm) {
                const formData = new FormData(customOptionsForm);
                customOptionsForm.querySelectorAll('[required]').forEach(field => {
                    if (!formData.get(field.name)) {
                        field.classList.add('error');
                        isValid = false;
                    } else {
                        field.classList.remove('error');
                        customOptionsData[field.name] = formData.get(field.name);
                    }
                });
            }
        }

        if (customTextarea && !customTextarea.value.trim()) {
            customTextarea.classList.add('error');
            isValid = false;
        } else if (customTextarea) {
            customOptionsData['Imprint'] = customTextarea.value.trim();
            customTextarea.classList.remove('error');
        }

        if (isValid) {
            if (selectedVariant) {
                selectedVariant.customOptions = Object.entries(customOptionsData).map(([name, value]) => ({
                    name,
                    value,
                }));

                input.closest('tr').dataset.customOptions = JSON.stringify(customOptionsData);

                selectProduct(selectedVariant, product, input);
            }
            closeVariantModal();
        } else {
            alert('Please fill in all required fields before proceeding.');
        }
    };

    modalList.appendChild(confirmBtn);
}

function closeVariantModal() {
    document.getElementById('variantModal').style.display = 'none';
    document.getElementById('modalBackdrop').style.display = 'none';
}

async function addToCart() {
    const rows = document.querySelectorAll('tbody tr');
    const cartItems = [];

    rows.forEach(row => {
        const skuInput = row.querySelector('.sku-input');
        if (skuInput && skuInput.value) {
            const variantId = row.dataset.variantId;
            const qty = parseInt(row.querySelector('.qty-input').value, 10);

            if (variantId && qty > 0) {
                const customOptions = row.dataset.customOptions
                    ? JSON.parse(row.dataset.customOptions)
                    : {};

                cartItems.push({
                    id: variantId,
                    quantity: qty,
                    properties: customOptions,
                });
            }
        }
    });

    if (cartItems.length > 0) {
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ items: cartItems })
            });

            if (response.ok) {
                localStorage.setItem('quickOrderMessage', JSON.stringify({
                    type: 'success',
                    text: `Successfully added ${cartItems.length} items to the cart.`,
                }));
                location.reload();
            } else {
                const errorData = await response.json();
                const errorMessage = errorData?.message || errorData?.description || 'Unknown error';
                alert(`Error adding items to the cart: ${errorMessage}`);
            }
        } catch (error) {
            console.error('Error adding products to cart:', error);
            alert('Error adding products to the cart. Please try again.');
        }
    } else {
        alert('No products selected.');
    }
}

function displayMessage(container, message, type) {
    container.innerHTML = '';
    const messageElement = document.createElement('div');
    messageElement.textContent = message;
    messageElement.className = `quick-order-message-${type}`;
    container.appendChild(messageElement);

    setTimeout(() => {
        container.innerHTML = '';
    }, 5000);
}

function handleQuickOrderMessage() {
    const messageDiv = document.querySelector('.quick-order-message');
    const messageData = localStorage.getItem('quickOrderMessage');
    if (messageData) {
        const { type, text } = JSON.parse(messageData);
        displayMessage(messageDiv, text, type);
        localStorage.removeItem('quickOrderMessage');
    }
}

function showQtyRulesPopup(infoIcon) {
    const qtyInput = infoIcon.parentElement.querySelector('.qty-input');

    const minCartQty = parseInt(qtyInput.min, 10) || 1;
    const qtyIncrements = parseInt(qtyInput.step, 10) || 1;
    const maxCartQty = parseInt(qtyInput.max, 10) || 100000;

    const existingPopup = document.querySelector('.qty-rules-popup');
    if (existingPopup) {
        existingPopup.remove();
    }

    const popup = document.createElement('div');
    popup.classList.add('qty-rules-popup');

    let popupContent = `<div><strong>Quantity Rules:</strong></div><ul>`;
    if (minCartQty > 1) {
        popupContent += `<li>Minimum quantity: ${minCartQty}</li>`;
    }
    if (qtyIncrements > 1) {
        popupContent += `<li>Quantity increments: ${qtyIncrements}</li>`;
    }
    if (![0, 10000, 100000].includes(maxCartQty)) {
        popupContent += `<li>Maximum quantity: ${maxCartQty}</li>`;
    }
    popupContent += `</ul>`;

    popup.innerHTML = popupContent;

    infoIcon.appendChild(popup);
}

function updateSubtotal(qtyInput) {
    const row = qtyInput.closest('tr');
    const price = parseFloat(qtyInput.dataset.productPrice) || 0;
    const qty = parseInt(qtyInput.value, 10) || 0;
    const subtotal = row.querySelector('.subtotal');
    subtotal.textContent = `$${(price * qty).toFixed(2)}`;
}

function resetRow(row) {
    const singleRow = row.closest('tr');

    singleRow.querySelector('.sku-input').value = '';

    singleRow.querySelector('.product-photo').innerHTML = '';

    singleRow.querySelector('.product-details').innerHTML = '';

    const qtyInput = singleRow.querySelector('.qty-input');
    qtyInput.value = '1';
    qtyInput.disabled = true;

    qtyInput.classList.remove('error');

    const infoIcon = qtyInput.nextElementSibling;
    if (infoIcon && infoIcon.classList.contains('info-icon')) {
        infoIcon.remove();
    }

    singleRow.querySelector('.subtotal').textContent = '';

    singleRow.querySelector('.reset-btn').disabled = true;
    singleRow.querySelector('.edit-btn').disabled = true;
}

async function editRow(row) {
    const singleRow = row.closest('tr');
    const productId = singleRow.dataset.variantId;
    const productTitle = singleRow.dataset.productTitle;

    if (!productId) {
        alert('Product ID not found for this row.');
        return;
    }

    try {
        const products = await fetchProducts(productTitle);
        const product = products.find(product =>
            product.variants.some(variant => variant.variantId === productId)
        );

        if (!product) {
            alert('Product not found for this row.');
            return;
        }

        const hasCustomOptions = product.customOptionsForm && product.customOptionsForm.fields.length > 0;

        if (product.variants.length > 1 || hasCustomOptions) {
            const input = singleRow.querySelector('.sku-input');
            openVariantModal(product, input);
        } else {
            alert('This product has only one variant and no custom options to edit.');
        }
    } catch (error) {
        console.error('Error fetching product details:', error);
        alert('An error occurred while fetching product details. Please try again.');
    }
}

function addLine() {
    const tableBody = document.getElementById('product-table-body');
    const newRow = document.createElement('tr');

    newRow.classList.add('product-row');
    newRow.innerHTML = `
        <td>
            <input type="text" class="sku-input" placeholder="Enter SKU...">
            <ul class="dropdown"></ul>
        </td>
        <td class="product-photo"></td>
        <td class="product-details"></td>
        <td>
            <input type="number" class="qty-input" value="1" min="1" disabled>
        </td>
        <td class="subtotal"></td>
        <td>
            <button id="edit-btn" class="edit-btn" disabled>Edit</button>
        </td>
        <td>
            <button id="reset-btn" class="reset-btn" disabled>Reset</button>
        </td>
    `;

    tableBody.appendChild(newRow);
}

function downloadCSV() {
    const rows = document.querySelectorAll('#product-table-body tr');
    const data = [];

    rows.forEach(row => {
        const skuInput = row.querySelector('.sku-input');
        const qtyInput = row.querySelector('.qty-input');

        if (skuInput.value && qtyInput.value > 0) {
            const rowData = [
                skuInput.value,
                qtyInput.value,
            ];
            data.push(rowData);
        }
    });

    const headers = ['SKU', 'Quantity'];
    data.unshift(headers);

    const csvContent = data.map(row => row.join(',')).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'quick_order.csv';
    link.click();
}

function uploadCSV() {
    const fileInput = document.getElementById('upload-csv-input');
    const file = fileInput.files[0];

    const reader = new FileReader();
    reader.onload = function(event) {
        const csvData = event.target.result;
        const rows = csvData.split('\n');

        rows.shift();

        rows.forEach(row => {
            const columns = row.split(',');

            if (columns.length < 2) return;

            const sku = columns[0].trim();
            const quantity = parseInt(columns[1].trim(), 10);

            fetchProductDetails(sku, quantity);
        });
        fileInput.value = '';
    };

    reader.readAsText(file);
}

async function fetchProductDetails(sku, quantity) {
    const products = await fetchProducts(sku);

    let foundVariant = null;

    products.forEach(product => {
        product.variants.forEach(variant => {
            const formattedSku = (variant.sku || '').trim();

            if (formattedSku === sku) {
                foundVariant = { product, variant };
            }
        });
    });

    if (!foundVariant) {
        alert(`Product with SKU ${sku} not found`);
        console.error(`Product with SKU ${sku} not found`);
        return;
    }

    const { product, variant } = foundVariant;

    // Check if the product has custom options or if the variant is "Custom"
    const hasCustomOptions = product.customOptionsForm && product.customOptionsForm.fields.length > 0;
    const isCustomVariant = variant.options.some(option => option.value.toLowerCase() === 'custom');

    if (hasCustomOptions || isCustomVariant) {
        alert(`The product "${product.title}" has required custom options or is a "Custom" variant and cannot be added via CSV. Please add it manually.`);
        return;
    }

    addRowFromCSV(
        sku,
        quantity,
        variant.id,
        variant.price,
        product.title,
        product.handle,
        variant.image,
        getVariantInfo(variant)
    );
}

function extractVariantId(gid) {
    const regex = /gid:\/\/shopify\/ProductVariant\/(\d+)/;
    const match = gid.match(regex);
    return match ? match[1] : null;
}

async function addRowFromCSV(sku, quantity, variantId, price, productTitle, productHandle, productImage, variantInfo) {
    const tableBody = document.getElementById('product-table-body');
    const numericVariantId = extractVariantId(variantId);

    if (!numericVariantId) {
        console.error("Invalid variant ID:", variantId);
        return;
    }

    const products = await fetchProducts(sku);
    const product = products.find(p => p.variants.some(v => v.id === variantId));

    if (!product) {
        console.error("Product not found for variant:", variantId);
        return;
    }

    if (product.customOptionsForm && product.customOptionsForm.fields.length > 0) {
        const requiredFields = product.customOptionsForm.fields.filter(field =>
            field.some(f => f.key === 'option_is_required' && f.value === 'true')
        );

        if (requiredFields.length > 0) {
            alert(`The product "${productTitle}" has required custom options and cannot be added via CSV. Please add it manually.`);
            return;
        }
    }

    const { minCartQty, qtyIncrements, maxCartQty } = product;
    const hasQtyRules =
        (minCartQty !== null && minCartQty > 1) ||
        (qtyIncrements !== null && qtyIncrements > 1) ||
        (maxCartQty !== null && ![0, 10000, 100000].includes(maxCartQty));

    const newRow = document.createElement('tr');
    newRow.classList.add('product-row');
    newRow.setAttribute('data-variant-id', numericVariantId);
    newRow.setAttribute('data-product-title', productTitle);

    newRow.innerHTML = `
        <td>
            <input type="text" class="sku-input" value="${sku}" placeholder="Enter SKU...">
            <ul class="dropdown"></ul>
        </td>
        <td class="product-photo">
            <img src="${productImage}" alt="${productTitle}">
        </td>
        <td class="product-details">
            <a href="/products/${productHandle}?variant=${numericVariantId}" class="product-details-title">${productTitle}</a>
            <span class="variant-info">${variantInfo}</span><br>
            $${price.toFixed(2)}
        </td>
        <td>
            <div class="qty-container">
                <input 
                    type="number" 
                    class="qty-input" 
                    value="${quantity}" 
                    min="${minCartQty || ''}" 
                    max="${maxCartQty || ''}" 
                    step="${qtyIncrements || ''}" 
                    data-variant-id="${numericVariantId}" 
                    data-product-price="${price}">
                ${hasQtyRules ? `<span class="info-icon">i</span>` : ''}
            </div>
        </td>

        <td class="subtotal">$${(price * quantity).toFixed(2)}</td>
        <td>
            <button class="edit-btn">Edit</button>
        </td>
        <td>
            <button class="reset-btn">Reset</button>
        </td>
    `;

    tableBody.insertBefore(newRow, tableBody.firstChild);

    const qtyInput = newRow.querySelector('.qty-input');
    const infoIcon = newRow.querySelector('.info-icon');

    const validateQty = () => {
        const currentQty = parseInt(qtyInput.value, 10);
        const isInvalid =
            (minCartQty !== null && currentQty < minCartQty) ||
            (maxCartQty !== null && currentQty > maxCartQty);

        if (isInvalid) {
            qtyInput.classList.add('error');
            if (infoIcon) infoIcon.classList.add('error');
        } else {
            qtyInput.classList.remove('error');
            if (infoIcon) infoIcon.classList.remove('error');
        }
    };

    qtyInput.addEventListener('input', validateQty);

    validateQty();
}
